<template>
  <div id="app">
    <header>
      <div class="navbar-fixed">
        <nav>
          <div class="nav-wrapper white">
            <a
              href="https://www.tebelopele.org.bw"
              class="brand-logo margin-left-half right"
            >
              <img
                src="@/assets/img/tebelopele_logo.png"
                style="height: 1.7em"
              />
            </a>
            <ul class="margin-right-8 right">
              <li  class="nav-content">
                <a
                  href="https://www.tebelopeleclinics.org.bw/myhealthassessment/login"
                  target="_blank"
                  class=" deep-orange-text text-darken-1 right"
                  >Login</a
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <main class="py-4"></main>
    <message-modal-component :messages="messages"></message-modal-component>
    <confirm-modal-component
      :action-name="actionName"
    ></confirm-modal-component>
    <loading-component></loading-component>
    <router-view />
  </div>
</template>
<style>
@import "assets/appsheet.css";
@import "assets/borders.css";
@import "assets/loader.css";
@import "assets/padding.css";
@import "assets/margin.css";
@import "assets/password-meter.css";
@import "assets/style.css";
@import "assets/vert-offset.css";
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -moz-border-radius: inherit;
  text-align: center;
}
.logo-img {
  width: 60px;
}
body {
  background-color: rgba(224, 226, 222, 0.45);
}
#nav {
  padding: 30px;
}
body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  contain: content;
  justify-content: center;
  -ms-grid-column-align: inherit;
}

main {
  flex: auto;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<script>
import LoadingComponent from "@/components/materiallize/LoadingComponent";
import http from "@/http-common";
import { mapState } from "vuex";
import MessageModalComponent from "@/components/materiallize/MessageModalComponent";
import ConfirmModalComponent from "@/components/materiallize/ConfirmModalComponent";

export default {
  components: {
    ConfirmModalComponent,
    LoadingComponent,
    MessageModalComponent
  },
  computed: {
    ...mapState({
      messages: state => state.messages,
      actionName: state => state.actionName
    })
  },
  mounted() {
    http.interceptors.response.use(
      response => {
        console.log("* Response" + JSON.stringify(response));
        if (response.data.success == false) {
          return Promise.reject(response);
        }
        return response;
      },
      error => {
        var response = {
          data: {
            messages: [error.message]
          },
          message: error.message
        };

        return Promise.reject(response);
      }
    );
  }
};
</script>
